<template>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <div class="section-gap">
        <div class="block">
          <div class="ad-set-module-container">
            <p class="title">展示时间段</p>
            <div class="block">
              <el-date-picker
                      :disabled="timeAbleStart"
                      v-model="initialData.startTime"
                      type="datetime"
                      placeholder="开始时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
              <span class="r-top">~</span>
              <el-date-picker
                      :disabled="timeAbleEnd"
                      v-model="initialData.endTime"
                      type="datetime"
                      placeholder="结束时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </div>

            <p class="title">关联抽象券</p>
            <input class="block input width-3" :disabled="isAble" v-model="initialData.abstractId" placeholder="请输入抽象券ID">
            <a :href="`/admin.php?method=novicegift.showDefinitionList&groupId=31`" target="_blank">查看抽象券列表>></a>

            <div class="clearfix">
              <div class="fleft">
                <p class="title">领取前图片</p>
                <div class="block">
                  <span class="button is-primary" id="js_imageUploadBtn_before" style="line-height: 30px;">上传领取前图片</span>
                  <span class="upload-img-tips">只能上传 jpg/png 文件，图片尺寸小于1M,「建议尺寸：540x706」</span>
                </div>
                <div class="block">
                  <image-component :image="initialData.beforeImage" :width="300"></image-component>
                </div>
              </div>
              <div class="fleft margin-left1">
                <p class="title">领取后图片</p>
                <div class="block">
                  <span class="button is-primary" id="js_imageUploadBtn_after" style="line-height: 30px;">上传领取后图片</span>
                  <span class="upload-img-tips">只能上传 jpg/png 文件，图片尺寸小于1M,「建议尺寸：540x706」</span>
                </div>
                <div class="block">
                  <image-component :image="initialData.afterImage" :width="300"></image-component>
                </div>
              </div>
            </div>

            <p class="title">跳转页面（非必填项）</p>
            <div class="block cyzs-w-400">
              <custom-link :link='initialData.link' @update:link="val => { initialData.link = val }"></custom-link>
              <p style="color:gray">注：填写后，点击领取后图片将跳转至此链接</p>
            </div>

            <p style="text-align:left;">
              <el-button type="primary" style="margin: 60px 0 40px 0;" @click="saveModuleClick">确定</el-button>
              <el-button type="success" style="margin: 60px 0 40px 0;" @click="backClick">取消</el-button>
            </p>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
<script type="text/babel">
import Uploader from 'COMMON/uploaderModule/uploader'
import CustomLink from 'COMMON/DefinedLink'
import { getTimeByTimeString } from 'UTILS/date'

export default {
  components: { CustomLink },
  data () {
    return {
      timeAbleStart: false, // 开始时间是否可修改
      timeAbleEnd: false, // 开始时间是否可修改
      isAble: false, // 时间是否可修改
      // 模块设置
      initialData: {
        startTime: '',
        endTime: '',
        abstractId: '',
        beforeImage: {
          image: '',
          width: 0,
          height: 0
        },
        afterImage: {
          image: '',
          width: 0,
          height: 0
        },
        link: ''
      },
      popId: 0
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.uploadBefore()
      this.uploadAfter()
    })
    if (this.$route.query.popId) {
      this.popId = this.$route.query.popId
      this.isAble = true
      if (this.$route.query.status == 0) {
        this.timeAbleStart = false
        this.timeAbleEnd = false
      } else if (this.$route.query.status == 1) {
        this.timeAbleStart = true
        this.timeAbleEnd = false
      } else {
        this.timeAbleStart = true
        this.timeAbleEnd = true
      }
    }
    this.getInit()
  },
  methods: {
    uploadBefore () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#js_imageUploadBtn_before',
            multiple: true
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image',
          fileSizeLimit: 1 * 1024 * 1024,
          fileSingleSizeLimit: 1 * 1024 * 1024
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.initialData.beforeImage.image = response.data.images.info.path
            this.initialData.beforeImage.width = response.data.images.info.width
            this.initialData.beforeImage.height = response.data.images.info.height
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    },
    uploadAfter () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#js_imageUploadBtn_after',
            multiple: true
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image',
          fileSizeLimit: 1 * 1024 * 1024,
          fileSingleSizeLimit: 1 * 1024 * 1024
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.initialData.afterImage.image = response.data.images.info.path
            this.initialData.afterImage.width = response.data.images.info.width
            this.initialData.afterImage.height = response.data.images.info.height
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    },

    getInit () {
      HttpRequest.get('/admin.php?method=miniprogram.getPopCoupon', {popId: this.popId}, true).then((response) => {
        this.initialData = Object.assign(this.initialData, response.data)
      }, (response) => {

      })
    },

    // 保存模块设置
    saveModuleClick () {
      if (!this.initialData.startTime || !this.initialData.endTime) {
        this.$message('时间不能为空')
      } else if (getTimeByTimeString(this.initialData.startTime) > getTimeByTimeString(this.initialData.endTime)) {
        this.$message('结束时间不能小于开始时间')
      } else if (!this.initialData.abstractId) {
        this.$message('关联抽象券不能为空')
      } else if (!this.initialData.beforeImage.image || !this.initialData.afterImage.image) {
        this.$message('上传前后图片不能为空')
      } else {
        let params = this.initialData
        params.popId = this.popId
        HttpRequest.post('/admin.php?method=miniprogram.doSavePopCoupon', params, true).then((response) => {
          if (response.result == 0) {
            this.$message('保存成功')
            setTimeout(() => {
              this.$router.push({
                name: 'couponsPop'
              })
            }, 1500)
          } else {
            this.$message(response.msg)
          }
        }, (response) => {

        })
      }
    },
    backClick () {
      this.$router.push({
        name: 'couponsPop'
      })
    }

  }
}
</script>
<style lang="less" scoped>
  .ad-list-container{
    margin: 30px 0;
    .list-cell{
      .title{
        margin-bottom: 100px;
      }
      .time{
        margin-bottom: 20px;
      }
      .sort-wrap{
        margin-top: 34px;
      }
    }
  }
  .ad-set-module-container{
    margin: 30px 0 0 4px;
    .slider-wrap{
      width: 300px;
      margin-top: 40px;
      .tooltip-value{
        margin-left: 20px;
      }
      .input-slider{
        margin-top: 30px;
      }
    }
  }
  .white-space {
    white-space: normal;
  }
  .custom-link-wrap{
    border-radius: 6px;
    border: 1px solid #00d1b2;
    width: 300px;
    padding: 20px;
  }
</style>
